import { Role } from '@okletsplay/core';
import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { rolesGuard } from 'app/routing/guards';
import { lazyRetry } from 'app/utils';
import PlayerViewPage from 'modules/users/pages/PlayerViewPage';

const PlayersPage = lazyRetry(() => import('modules/users/pages/PlayersPage'));
const PlayerEditPage = lazyRetry(() => import('modules/users/pages/PlayerEditPage'));

export const UsersRoutes: GuardedRoute[] = [
  {
    path: Route.PlayersRoot,
    name: 'Players',
    component: PlayersPage,
    availability: [Role.User],
    guards: [rolesGuard([Role.User])],
  },
  {
    path: Route.PlayerMyProfileEdit,
    name: 'Player',
    component: PlayerEditPage,
    availability: [Role.User],
    guards: [rolesGuard([Role.User])],
  },
  {
    path: Route.Player,
    name: 'Player',
    component: PlayerViewPage,
    availability: [],
    guards: [],
  },
];
